import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { aggregation } from './products/aggregation.mjs';
import { standard16PoE } from './products/standard16PoE.mjs';
import { standard24 } from './products/standard24.mjs';
import { standard24PoE } from './products/standard24PoE.mjs';
import { standard48 } from './products/standard48.mjs';
import { standard48PoE } from './products/standard48PoE.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { portCount } from './properties/portCount.mjs';
import { downlinkSpeed } from './properties/downlinkSpeed.mjs';
import { uplinkSpeed } from './properties/uplinkSpeed.mjs';
import { poeOutput } from './properties/poeOutput.mjs';
import { poeAvailability } from './properties/poeAvailability.mjs';
"use strict";
const SwitchingValue = {
  properties: [dimensions, portCount, downlinkSpeed, uplinkSpeed, poeOutput, poeAvailability],
  products: [aggregation, standard48PoE, standard24PoE, standard16PoE, standard48, standard24],
  columnWidth: TABLE_COLUMN_WIDTH
};
export { SwitchingValue };
//# sourceMappingURL=SwitchingValue.mjs.map
